<template>
  <div class="container">
    <headTop />
    <div class="container">
      <div class="content">
        <!-- 面包屑 -->
        <div class="nav">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">{{
              $t("navbar.home")
            }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t("navbar.live") }}</el-breadcrumb-item>
          </el-breadcrumb>
          <div class="search">
            <p>{{ $t("navbar.live") }}</p>
            <div class="serach_content" @keyup.enter="search">
              <el-input :placeholder="$t('live.placeholder')" v-model="input">
              </el-input>
              <el-button
                type="primary"
                icon="el-icon-search"
                class="search_button"
                @click="search"
              ></el-button>
            </div>
          </div>
        </div>
        <!-- 选择展会 -->
        <el-radio-group v-model="hz" @change="hzChange">
          <el-radio-button :label="0">{{
            $t("live.hzbutton1")
          }}</el-radio-button>
          <el-radio-button :label="1">{{
            $t("live.hzbutton2")
          }}</el-radio-button>
        </el-radio-group>
        <!-- 标签页 -->
        <div class="tab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in tabList"
              :key="index"
              :label="item.title"
              :name="item.val"
            >
              <!-- 直播内容框 -->
              <div class="live-box">
                <div
                  class="item"
                  v-for="(item, index) in liveDate"
                  :key="index"
                  @click="liveDetail(item)"
                >
                  <div class="vedio">
                    <img
                      :src="
                        item.collectStatus
                          ? require('../../static/collent_yello.png')
                          : require('../../static/collent.png')
                      "
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img :src="item.coverPhoto" class="fengmian" alt="" />
                    <div class="fixed">
                      <div class="banner-btn">
                        <img src="../../static/ico_vedio.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="title">
                    <p>{{ item.liveCn }}</p>
                    <div class="title_icon">
                      <img src="../../static/ico-time.png" alt="" />
                      <p style="color: #666666; font-size: 16px">
                        {{ item.startDate }}
                      </p>
                    </div>
                  </div>
                  <div class="down">
                    <p>{{ item.exhibitorNameCn }}</p>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <!-- <el-tab-pane :label="$t('live.tab2')" name="second">
            
              <div class="live-box">
                <div
                  class="item"
                  v-for="(item, index) in liveDate"
                  :key="index"
                  @click="liveDetail(item)"
                >
                  <div class="vedio">
                    <img
                      :src="
                        item.collectStatus
                          ? require('../../static/collent_yello.png')
                          : require('../../static/collent.png')
                      "
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img :src="item.coverPhoto" class="fengmian" alt="" />
                    <div class="fixed">
                      <div class="banner-btn">
                        <img src="../../static/ico_vedio.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="title">
                    <p>{{ item.liveCn }}</p>
                    <div class="title_icon">
                      <img src="../../static/ico-time.png" alt="" />
                      <p style="color: #666666; font-size: 16px">
                        {{ item.startDate }}
                      </p>
                    </div>
                  </div>
                  <div class="down">
                    <p>{{ item.exhibitorNameCn }}</p>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('live.tab3')" name="third">
           
              <div class="live-box">
                <div
                  class="item"
                  v-for="(item, index) in liveDate"
                  :key="index"
                  @click="liveDetail(item)"
                >
                  <div class="vedio">
                    <img
                      :src="
                        item.collectStatus
                          ? require('../../static/collent_yello.png')
                          : require('../../static/collent.png')
                      "
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img
                      :src="item.coverPhoto"
                      class="fengmian"
                      alt=""
                      v-if="item.coverPhoto.includes('/')"
                    />
                    <img src="../../static/占位-展品-列表.png" alt="" v-else />
                    <div class="fixed">
                      <div class="banner-btn">
                        <img src="../../static/ico_vedio.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="title">
                    <p>{{ item.liveCn }}</p>
                    <div class="title_icon">
                      <img src="../../static/ico-time.png" alt="" />
                      <p style="color: #666666; font-size: 16px">
                        {{ item.startDate }}
                      </p>
                    </div>
                  </div>
                  <div class="down">
                    <p>{{ item.exhibitorNameCn }}</p>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('live.tab4')" name="four">
        
              <div class="live-box">
                <div
                  class="item"
                  v-for="(item, index) in liveDate"
                  :key="index"
                  @click="liveDetail(item)"
                >
                  <div class="vedio">
                    <img
                      :src="
                        item.collectStatus
                          ? require('../../static/collent_yello.png')
                          : require('../../static/collent.png')
                      "
                      @click.stop="toggle(item)"
                      class="shoucang"
                      alt=""
                    />
                    <img :src="item.coverPhoto" class="fengmian" alt="" />
                    <div class="fixed">
                      <div class="banner-btn">
                        <img src="../../static/ico_vedio.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <div class="title">
                    <p>{{ item.liveCn }}</p>
                    <div class="title_icon">
                      <img src="../../static/ico-time.png" alt="" />
                      <p style="color: #666666; font-size: 16px">
                        {{ item.startDate }}
                      </p>
                    </div>
                  </div>
                  <div class="down">
                    <p>{{ item.exhibitorNameCn }}</p>
                  </div>
                </div>
              </div>
            </el-tab-pane> -->
          </el-tabs>
          <!--分页 -->
          <div class="pagination">
            <span>{{ $t("common.pagination", { allNum: total1 }) }}</span>
            <el-pagination
              v-if="pageshow"
              class="explore_right_pages"
              layout="prev, pager, next"
              :background="isBackground"
              :current-page="currentPage4"
              @current-change="handleCurrentChange"
              :page-size="16"
              :total="total1"
            >
            </el-pagination>
          </div>
          <!-- alert 弹框 -->
          <div class="alert_mess" v-show="visible">
            <img class="close" @click="close" src="../../static/close.png" />
            <div>
              <div class="qrcode">
                <img :src="livePhoto" alt="" />
              </div>
              <p>{{ $t("live.tip") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot-bottom />
  </div>
</template>

<script>
import headTop from "../../common/head.vue";
import footBottom from "../../common/footBottom.vue";
import { getLiveInfo, getShoucang } from "../../../api/livePage";
import * as tools from "../../../utils/roulink";
import { forMat } from "../../../utils/common";
import { live } from "../../assets/i18n/zh";
export default {
  data() {
    return {
      isBackground: true,
      activeName: "",
      collent_toggle: true, //收藏按钮
      input: "", //输入框的内容
      currentPage4: 1, //分页当前页
      visible: false, //弹框可见
      total1: 1,
      baseUrl: forMat(),
      // 直播返回数据
      liveDate: [],
      //tab列表
      tabList: [],
      hz: 0, //选择展会
      // 直播请求数据
      liveForm: {
        pageNo: 1,
        pageSize: 12,
        keyword: "",
        date: "",
      },
      // tag标签时间当前的
      tagData: this.$t("live.tab1"),
      // 二维码图片
      livePhoto: "",
      pageshow: true,
    };
  },

  components: {
    headTop,
    footBottom,
  },

  computed: {},
  created() {
    // this.getLive();
  },
  mounted() {
    this.getTabs();
  },
  methods: {
    getTabs() {
      this.tabList = [];
      let obj = live.tabList[this.hz];
      for (const key in obj) {
        let tab = `live.tabList.${this.hz}.${key}`;
        this.tabList.push({
          val: obj[key],
          title: this.$t(tab),
        });
      }
      this.activeName = this.tabList[0].val;
      this.handleClick();
    },
    hzChange(e) {
      this.getTabs();
    },
    // 请求数据
    async getLive() {
      const datas = await getLiveInfo(this.liveForm);
      this.liveDate = datas.data.data.list;
      this.liveDate.forEach((item, i) => {
        if (item.coverPhoto.indexOf("http") == -1) {
          this.liveDate[i].coverPhoto = forMat() + this.liveDate[i].coverPhoto;
        }
      });

      this.total1 = datas.data.data.count;
    },
    //标签切换事件
    handleClick(tab, event) {
      // if (tab.label == this.$t("live.tab1")) {
      //   this.tagData = "10月25日";
      // } else if (tab.label == this.$t("live.tab2")) {
      //   this.tagData = "10月26日";
      // } else if (tab.label == this.$t("live.tab3")) {
      //   this.tagData = "10月27日";
      // } else if (tab.label == this.$t("live.tab4")) {
      //   this.tagData = "10月28日";
      // }
      this.tagData = this.activeName;
      this.liveForm = {
        pageNo: 1,
        pageSize: 12,
        date: this.tagData,
        currentExpo: !this.hz * 1,
      };
      this.getLive();
    },
    //分页点击事件
    handleCurrentChange(val) {
      this.liveForm = {
        pageNo: val,
        pageSize: 12,
        keyword: this.input,
        date: this.tagData,
      };
      this.getLive();
      console.log(`当前页: ${val}`);
    },
    //search查询搜索框
    search() {
      this.liveForm = {
        pageNo: "1",
        pageSize: 12,
        keyword: this.input,
        date: "",
      };
      this.currentPage4 = 1;
      this.pageshow = false;
      this.getLive();
      this.$nextTick(() => {
        this.pageshow = true;
      });
    },
    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },
    //判断点击收藏状态
    async toggle(item) {
      const shouDetail = {
        objId: item.id,
        flag: !item.collectStatus,
        type: 3,
      };
      try {
        const data = await getShoucang(shouDetail);
        if (data.data.code === 200) {
          item.collectStatus = !item.collectStatus;
          if (item.collectStatus) {
            this.$message({
              showClose: true,
              message: this.$t("common.successCollect"),
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: this.$t("common.cancelCollect"),
              type: "error",
            });
          }
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.data.msg,
          //   type: 'warning',
          // });
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },
    //关闭弹窗
    close() {
      this.visible = false;
    },
    // 点击跳转直播详情
    liveDetail(item) {
      console.log(item);
      if (item.videoType == 1) {
        this.$router.push({ name: "live_detail", query: { userId: item.id } });
      } else if (item.videoType == 2) {
        window.open(item.videoAddress);
      } else if (item.videoType == 3) {
        this.visible = true;

        if (item.videoAddress.indexOf("http") == -1) {
          item.videoAddress = forMat() + item.videoAddress;
        }
        this.livePhoto = item.videoAddress;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  // height: 1800px;
  margin-top: 120px;
  // margin-bottom: 70px;
  .content {
    width: 1270px;
    margin: 0 auto;
    .search {
      display: flex;
      // border: 1px solid red;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 41px;
      margin-top: 28px;
      .serach_content {
        display: flex;
        width: 620px;
        height: 40px;
      }
      .search_button {
        width: 70px;
        height: 40px;
        background: #006fb8;
      }
    }
    .nav p {
      // width: 60px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      display: block;
    }
    .tab {
      position: relative;
      .el-tabs__header {
        margin: 0 !important;
      }
      .live-box {
        display: flex;
        width: 1300px;
        flex-wrap: wrap;
        justify-content: flex-start;
        .item {
          width: 401px;
          height: 387px;
          margin-top: 30px;
          margin-right: 30px;
          border: 1px solid #e0e0e0;
          .vedio {
            width: 401px;
            height: 227px;
            position: relative;
            .shoucang {
              position: absolute;
              z-index: 9;
              right: 10px;
              top: 10px;
            }
            .fengmian {
              width: 100%;
              height: 100%;
            }
            .fixed {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              background-color: rgba(30, 30, 30, 0.3);
              display: none;
              img {
                // margin: 88px 176px;
                width: 53px;
                height: 65px;
                margin: 71px 175px 91px;
              }
            }
          }
          .vedio:hover > .fixed {
            display: block;
          }

          .title {
            box-sizing: border-box;
            height: 99px;
            padding: 21px 28px 0 24px;
            p {
              padding-bottom: 20px;
              font-size: 18px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              word-break: break-all;
            }
            .title_icon {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              img {
                width: 19px;
                height: 19px;
                margin-right: 2px;
              }
            }
          }
          .down {
            border-top: 1px #e0e0e0 solid;
            height: 60px;
            p {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 60px;
              margin-left: 20px;
              color: #999999;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
              word-break: break-all;
            }
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      margin-bottom: 70px;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        margin-top: 9px;
      }
    }
    .alert_mess {
      width: 400px;
      height: 530px;
      box-sizing: border-box;
      //padding: 5px;
      text-align: center;
      // border: 1px solid black;
      box-shadow: 0px 0px 51px 0px #c1c6cb;
      background: white;
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      margin: auto;
      z-index: 99;
      display: flex;
      justify-content: center;
      align-items: center;

      .close {
        float: right;
        width: 24px;
        height: 24px;
        position: absolute;
        right: 15px;
        top: 15px;
      }
      .qrcode {
        max-width: 300px;
        max-height: 450px;
        img {
          width: 100%;
          height: 100%;
          max-width: 300px;
          max-height: 450px;
        }
      }
      p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        margin-top: 21px;
        font-weight: 400;
        color: #333333;
        //line-height: 33px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .explore_right_pages {
  display: flex;
  align-items: center;
  justify-content: center;
  .el-pagination button:hover {
    color: #978d8d;
  }
  .el-pagination button {
    color: #999999;
  }

  .el-pager li {
    background-color: unset;
  }
  .el-pager li:hover {
    color: #999999;
  }
  .btn-prev {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
    margin-left: 10px;
  }
  .btn-next {
    width: 32px;
    height: 32px;
    background: #f6f6f7;
    border-radius: 4px;
    border: 1px solid #cccccc;
    padding-left: 0;
    padding-right: 0;
    margin-right: 5px;
  }
  .el-pager .number {
    width: 32px;
    height: 32px;
    line-height: 32px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #cccccc;
    margin-right: 5px;
    margin-right: 5px;
    color: #999999;
  }
  .el-pager .number:hover {
    color: #006fb8;
  }
  .el-pager li.active {
    border: none;
    cursor: pointer;
    background: #006fb8 !important;
    color: #fff;
  }
  .el-pager li.active:hover {
    color: #fff;
    background: #006fb8;
  }
  .el-pager li.btn-quicknext {
    line-height: 28px;
    color: #999;
  }
}
.el-input {
  position: relative;
  font-size: 16px;
  display: inline-block;
  width: 100%;
}
.el-button {
  border-radius: 0px 4px 4px 0px;
}
.el-breadcrumb >>> .el-breadcrumb {
  margin: 24px 0 28px;
}

.tab >>> .el-tab-pane {
  //height: 1500px;
  margin-bottom: 33px;
}
.tab >>> .el-tabs__nav-wrap::after {
  background: white;
  position: static !important;
  height: 0;
}
</style>
<style scoped>
div /deep/ .el-tabs__item {
  font-size: 18px !important;
}
div /deep/ .el-input__inner {
  border: 1px solid #e0e0e0;
  border-radius: 4px 0 0 4px !important;
}
.el-tabs >>> .el-tabs__header {
  margin: 0;
}
</style>
